import { useEffect, useMemo } from 'react'
import { Modal, Select } from 'antd'
import { Queries } from 'admin/lib/Api'

export function ResendToQCRModal({
  isOpen,
  onClose,
  onSubmit,
  resendTemplateInput,
  setResendTemplateInput
}) {
  const { Option } = Select

  const availableTemplateNamesRaw = Queries.useTemplateNames()

  const availableTemplateNames = useMemo(() => {
    const availableTemplates: any[] = []
    if (availableTemplateNamesRaw.data) {
      availableTemplateNamesRaw.data.forEach(templateName => {
        availableTemplates.push(
          <Option key={templateName}>{templateName}</Option>
        )
      })
    }
    return [availableTemplates]
  }, [Option, availableTemplateNamesRaw.data])

  useEffect(() => {
    setResendTemplateInput('')
  }, [isOpen, setResendTemplateInput])

  const handleOnOK = () => {
    onSubmit()
  }

  return (
    <Modal
      title="Warning:"
      open={isOpen}
      onCancel={onClose}
      onOk={handleOnOK}
      width={'25rem'}
    >
      <div style={{ marginBottom: '1rem' }}>
        <label htmlFor="targetTemplate">Select target template</label>
        <Select
          id="targetTemplate"
          allowClear
          placeholder="Please select"
          value={resendTemplateInput}
          onChange={value => setResendTemplateInput(value)}
          showSearch
          className="filter-medium"
        >
          {availableTemplateNames}
        </Select>
      </div>
      <div>
        <p>
          Resending records to QCR may cause the existing record data to be
          overwritten.
        </p>
        <p>Are you sure? Click OK to continue.</p>
      </div>
    </Modal>
  )
}
